// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"styles_backgroundContainer__ipfQQ"};